/**
 * Runtime side of the build identity injected by `@kostbar/monitoring/vite`.
 *
 * The constants are declared here rather than in an ambient `.d.ts` so they stay scoped to this
 * module: order-web declares the same three names in its own `globals.d.ts`, and a global
 * declaration in a shared package would collide with it.
 */
declare const __APP_VERSION__: string | undefined
declare const __BUILD_HASH__: string | undefined
declare const __BUILD_TIME__: string | undefined

export interface BuildInfo {
  /** Train version, e.g. `1.7.0` or `1.6.0-12`. */
  version: string
  /** Short commit the artifact was built from. */
  commit: string
  /** ISO timestamp of the build. */
  buildTime: string
}

/**
 * Read the injected constants.
 * Guarded with `typeof` so an app bundled without the plugin degrades to `dev` instead of throwing
 * a ReferenceError at module load.
 */
export function getBuildInfo(): BuildInfo {
  return {
    version: typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev',
    commit: typeof __BUILD_HASH__ !== 'undefined' ? __BUILD_HASH__ : '',
    buildTime: typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : '',
  }
}

/** Single display string: `1.6.0-12+abc1234`, or just the version when no commit was stamped. */
export function formatBuildIdentity(info: BuildInfo = getBuildInfo()): string {
  return info.commit ? `${info.version}+${info.commit}` : info.version
}
